import {
  Box,
  GridItem,
  HStack,
  InputRightElement,
  Spinner,
  Switch,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useFormikContext } from "formik";
import React, { useState } from "react";
import { RentalScenarioCalculation } from "../../lib/models/rental/rental-calculation.model";
import SliderField from "../form-fields/SliderField";
import TextInputField from "../form-fields/TextInputField";

export interface RateOverrideProps {
  scenarios?: RentalScenarioCalculation[];
  isCalculating?: boolean;
  rateReduction?: number | string;
  disableInputs: boolean;
  maxRate?: string;
  currRate?: number;
  handleScenarioPercentages?: (baseRate: number) => number;
}

function RateOverride({
  scenarios,
  isCalculating,
  maxRate,
  rateReduction,
  currRate,
  handleScenarioPercentages,
  disableInputs,
}: RateOverrideProps) {
  const { setFieldValue } = useFormikContext<any>();

  const [isReduction, setIsReduction] = useState(!!rateReduction);

  const onOverrideTypeChange = () => {
    setFieldValue("finalRateOverride", "");
    setFieldValue("rateReductionOverride", "0.000");
    setIsReduction(!isReduction);
  };
  return (
    <>
      <GridItem colSpan={12}>
        <HStack>
          <Text>Custom Rate</Text>
          <Switch
            isChecked={!isReduction}
            onChange={onOverrideTypeChange}
            isDisabled={disableInputs}
          />
        </HStack>
      </GridItem>

      {isReduction ? (
        <>
          <GridItem colSpan={{ base: 12, lg: 6 }}>
            <SliderField
              label="Interest Rate Reduction"
              name="rateReductionOverride"
              defaultValue={0}
              precision={3}
              step={0.125}
              max={1.0}
              min={0}
              disabled={disableInputs}
            />
          </GridItem>
          {scenarios ? (
            <GridItem
              colSpan={{ base: 12, lg: 6 }}
              marginLeft={{ base: 0, lg: 2 }}
            >
              <Box>
                <Text marginBottom={2} fontSize="xs" fontWeight="medium">
                  Rate After Reduction
                </Text>
                <HStack justifyContent="space-between">
                  {scenarios.map((scenario, i) => {
                    return (
                      <VStack key={`scenario${i}`}>
                        <Text
                          color="#777676"
                          borderBottom="1px solid var(--chakra-colors-gray-200)"
                          fontSize="sm"
                        >
                          Scenario {i + 1}
                        </Text>
                        {isCalculating ? (
                          <HStack>
                            <Spinner
                              thickness="2px"
                              speed="0.65s"
                              emptyColor="gray.200"
                              color="brand.500"
                              size="sm"
                            />
                            <Text fontSize="sm">Calculating...</Text>
                          </HStack>
                        ) : (
                          <Text fontWeight="500">
                            {handleScenarioPercentages &&
                              handleScenarioPercentages(
                                scenario.initFixedInterestRate
                              ).toFixed(3)}
                            %
                          </Text>
                        )}
                      </VStack>
                    );
                  })}
                </HStack>
              </Box>
            </GridItem>
          ) : (
            <GridItem colSpan={{ base: 12, lg: 6 }}></GridItem>
          )}
        </>
      ) : (
        <>
          <GridItem colSpan={{ base: 12, lg: 6 }}>
            <TextInputField
              name="finalRateOverride"
              label="Final Rate Override"
              type="number"
              children={<InputRightElement children="%" />}
              helperText={
                maxRate
                  ? `Current Maximum Rate: ${maxRate}%`
                  : `Current Rate: ${currRate}%`
              }
              placeholder="No override"
              disabled={disableInputs}
            />
          </GridItem>

          <GridItem colSpan={{ base: 12, lg: 6 }}></GridItem>
        </>
      )}
    </>
  );
}

export default RateOverride;
